import React from "react";
import { Box, Paper, Skeleton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";

export const HistoricalTableSkeleton: React.FC = () => {
  const headerStyle = {
    fontWeight: 600,
    color: "text.secondary",
    background: "#f2f4f7",
    borderBottom: "1px solid #eaecf0",
  };

  const cellStyle = {
    fontSize: 14,
    color: "#101828",
    borderBottom: "1px solid #eaecf0",
    py: 2,
  };

  return (
    <Box>
      <Paper
        sx={{
          border: "1px solid #eaecf0",
          borderRadius: 0.75,
          boxShadow: "0px 1px 3px rgba(0, 0, 0, 0.1)",
          overflow: "hidden",
        }}
      >
        {/* Table count header */}
        <Box sx={{ px: 3, py: 2, borderBottom: "1px solid #eaecf0", background: "#ffffff" }}>
          <Skeleton variant="text" width={120} height={20} />
        </Box>

        <TableContainer sx={{ background: "#ffffff" }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell sx={headerStyle}>Date</TableCell>
                <TableCell sx={headerStyle}>Source</TableCell>
                <TableCell sx={headerStyle}>Meal Plan</TableCell>
                <TableCell sx={headerStyle} align="right">
                  TDEE
                </TableCell>
                <TableCell sx={headerStyle} align="right">
                  Active Energy
                </TableCell>
                <TableCell sx={headerStyle} align="right">
                  Resting Energy
                </TableCell>
                <TableCell sx={headerStyle} align="right">
                  Target Intake
                </TableCell>
                <TableCell sx={headerStyle} align="right">
                  Logged Intake
                </TableCell>
                <TableCell sx={headerStyle} align="right">
                  Energy Balance
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {[1, 2, 3, 4, 5, 6, 7].map((i) => (
                <TableRow key={i} hover>
                  <TableCell sx={cellStyle}>
                    <Skeleton variant="text" width={80} />
                  </TableCell>
                  <TableCell sx={cellStyle}>
                    <Skeleton variant="text" width={100} />
                  </TableCell>
                  <TableCell sx={cellStyle}>
                    <Skeleton variant="text" width={120} />
                  </TableCell>
                  <TableCell sx={cellStyle} align="right">
                    <Skeleton variant="text" width={80} sx={{ ml: "auto" }} />
                  </TableCell>
                  <TableCell sx={cellStyle} align="right">
                    <Skeleton variant="text" width={80} sx={{ ml: "auto" }} />
                  </TableCell>
                  <TableCell sx={cellStyle} align="right">
                    <Skeleton variant="text" width={80} sx={{ ml: "auto" }} />
                  </TableCell>
                  <TableCell sx={cellStyle} align="right">
                    <Skeleton variant="text" width={80} sx={{ ml: "auto" }} />
                  </TableCell>
                  <TableCell sx={cellStyle} align="right">
                    <Skeleton variant="text" width={80} sx={{ ml: "auto" }} />
                  </TableCell>
                  <TableCell sx={cellStyle} align="right">
                    <Skeleton variant="text" width={80} sx={{ ml: "auto" }} />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </Box>
  );
};
